const layout = {
  navigation: {
    dashboard: "Zentrale",
    ambulanzes: "Ambulanzen",
    priorityRequests: "Vormerkliste",
    assignments: "Aufgaben",
    clients: "Kund:innen",
    appointments: "Kalender",
    attendanceList: "Anwesenheitsliste",
    courtHearings: "Tagsatzungen",
    exchange: "Tauschbörse",
    takeover: "Übernahmebörse",
    edikte: "Edikte & OZUFs",
    dutySchedule: "Dienstplanung",
    internetRegistration: "Internetanmeldungen",
    systemSettings: "Systemeinstellungen",
    systemSettingsForbidden: "Sie haben keine Berechtigung, die Systemeinstellungen zu öffnen.",
    statistics: "Statistiken",
    calculators: "Rechner",
    dropzone: "DropZone",
    closeNavigation: "Menü einklappen",
    openNavigation: "Menü ausklappen",
  },
  header: {
    clientSmartSearch: {
      placeholder: "Kunde suchen: Nachname, SV-Nummer, Tel. Nr., Geburtsdatum, E-Mail und ID",
      search: "Suche",
      today: "Heute",
      myClients: "Meine Kund:innen (KZZ: {{currentUserAbb}})",
    },
    filter: "Kundenfilter öffnen",
    pageContent: "Seiteninhalt",
    mainNavigation: "Hauptnavigation",
    startPage: "Startseite",
    actionsMenu: "Aktionsmenü",
    userSettings: "Benutzereinstellungen",
  },
};

export default layout;
